import {
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
  PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_VIEWER,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
  PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
  ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER,
  RolodexPermissionsValues,
} from 'types'

export const DOC_METADATA_USER_EDITS_VIEW_PERMISSIONS: RolodexPermissionsValues[] =
  [
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_VIEWER,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_VIEWER,
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_EDITOR,
    PERMISSION_CANTILEVER_POWER_DOCUMENT_NAVIGATOR_ADMIN,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_VIEWER,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_UPLOADER,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ]

export const DOC_METADATA_USER_EDITS_EDIT_PERMISSIONS: RolodexPermissionsValues[] =
  [
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_EDITOR,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
    ROLE_CANTILEVER_DOCUMENT_NAVIGATOR_EDITOR,
  ]

export const DOC_METADATA_USER_EDITS_LABEL_PERMISSIONS: RolodexPermissionsValues[] =
  [
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_LABELER,
    PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_REVIEWER,
  ]

export const DOC_METADATA_USER_EDITS_DASHBOARD_PERMISSIONS: RolodexPermissionsValues[] =
  [PERMISSION_CANTILEVER_DOC_METADATA_USER_EDITS_DASHBOARD]
